import { Component } from '@angular/core';

@Component({
  selector: 'app-production-card-details',
  templateUrl: './production-card-details.component.html',
  styleUrl: './production-card-details.component.scss',
})
export class ProductionCardDetailsComponent {}
